<template>
    <div class="wrapper">
        <h1>{{ lang.main.download_ticket }}</h1>
        <section class="content-box">
            <div class="download-outerbox">
                <div class="download-box" @click="toggle('group')" :class="[type === 'separate' ? '' : 'active']">
                    <h2>{{ lang.main.group_ticket }}</h2>
                    <p>{{ lang.main.group_print }}</p>
                    <div v-if="type === 'group'">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="white"
                            class="checkmark"
                        >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                        </svg>
                    </div>
                </div>
                <div class="download-box" @click="toggle('separate')" :class="[type === 'separate' ? 'active' : '']">
                    <h2>{{ lang.main.separate_tickets }}</h2>
                    <p>{{ lang.main.separate_print }}</p>
                    <div v-if="type === 'separate'">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="white"
                            class="checkmark"
                        >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                        </svg>
                    </div>
                </div>
            </div>
            <template v-if="voucherEnabled">
                <!-- Voucher buttons, made to select either one or both -->
                <div class="voucher-infobox">
                    <h3>{{ lang.main.voucher_headline }}</h3>
                    <p>{{ lang.main.attach_voucher }}</p>
                    <p>{{ lang.main.choice }}</p>
                </div>
                <div class="download-outerbox download-outerbox__row">
                    <div
                        class="voucher-checkbox"
                        @click="toggleFredericia()"
                        :class="[chooseFredericia === true ? 'active' : '']"
                    >
                        <div v-if="chooseFredericia === true">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="white"
                                class="voucher-checkmark"
                            >
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                            </svg>
                        </div>
                        <p>Fredericia</p>
                    </div>
                    <div
                        class="voucher-checkbox"
                        @click="toggleMiddelfart()"
                        :class="[chooseMiddelfart === true ? 'active' : '']"
                    >
                        <div v-if="chooseMiddelfart === true">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="white"
                                class="voucher-checkmark"
                            >
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                            </svg>
                        </div>
                        <p>Middelfart</p>
                    </div>
                </div>
            </template>
            <a :href="downloadUrl + query" target="_blank">
                <button type="submit" class="download-button">{{ lang.main.download }}</button>
            </a>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        lang: Object,
        downloadUrl: String,
        tickets: Object,
    },

    data() {
        return {
            voucherEnabled: false,
            type: 'group',
            chooseMiddelfart: false,
            chooseFredericia: false,
        }
    },

    methods: {
        toggle(newType) {
            this.type = newType
        },
        toggleMiddelfart() {
            this.chooseMiddelfart = !this.chooseMiddelfart
        },
        toggleFredericia() {
            this.chooseFredericia = !this.chooseFredericia
        },
    },

    computed: {
        query() {
            let output = []
            if (this.type !== 'separate') {
                output.push('group=1')
            }
            if (this.chooseMiddelfart) {
                output.push('middelfart=1')
            }
            if (this.chooseFredericia) {
                output.push('fredericia=1')
            }
            return output.length === 0 ? '' : '?' + output.join('&')
        },
    },
}
</script>
